const PlayerEvents = {
    "AD_LOADING": "adloading",
    "ADS_LOAD_ERROR": "adsloaderror",
    "ADS_LOAD_TIMEOUT": "adsloadtimeout",
    "ADS_PLAY_ERROR": "adsplayerror",
    "ADS_PLAY_TIMEOUT": "adsplaytimeout",
    "ADS_TIMEOUT_ERROR": "adstimeouterror",
    "BITRATE_CHANGE": "bitrateChange",
    "BUFFER": "buffer",
    "CONTENT_CHANGE": "contentchange",
    "DISMISS_SHARE": "dismissShare",
    "DISPOSE": "dispose",
    "DURATION_CHANGE": "durationchange",
    "ENDED": "ended",
    "ERROR": "error",
    "FATAL_ERROR": "fatalError",
    "FULL_SCREEN_CHANGE": "fullscreenchange",
    "HLS_BRIDGE_ERROR": "hlsBridgeError",
    "HLS_BRIDGE_FATAL_ERROR": "hlsBridgeFatalError",
    "HLS_CUE_IN": "hlsCueIn",
    "HLS_CUE_OUT": "hlsCueOut",
    "HLS_CUE_OUT_LOADED": "hlsCueOutLoaded",
    "LOADED_METADATA": "loadedmetadata",
    "LOADED_METADATA_SHIM": "loadedmetadata_shim",
    "PAUSE": "pause",
    "PLAY": "play",
    "PLAY_PREROLL": "playPreroll",
    "PREPARED_MIDROLL": "preparemidroll",
    "READY": "ready",
    "REQUEST_SHARE": "requestShare",
    "RETRY": "retry",
    "SEEK_START": "seekStart",
    "SHARE": "share",
    "SHARE_ACTION": "share_action",
    "START_MIDROLL": "startmidroll",
    "TIMEUPDATE": "timeupdate",
    "TRACK_INFO": "track-info",
    "USER_ACTIVE": "useractive",
    "USER_INACTIVE": "userinactive",
    "VOLUME_CHANGE": "volumechange",
    "WATCHDOG_RELOAD": "watchdogreload",
    "BVP_VOLUME_CHANGE": "bvp_volumechange",
    "CONTINUOUS_PLAY_START": "continuousPlayStart",
    "COMPANION_AD": "companionAd",
    "VIDEO_CHANGE": "videoChange",
    "REPLAY": "replay",
    "MUTED_OVERLAY_SHOW": "mutedOverlayShow",
    "MUTED_OVERLAY_CLICKED": "mutedOverlayClicked",
    "FOUNDATION_OVERLAY_CLICKED": "foundationOverlayClicked",
    "SUBSCRIBER_STATUS_CHANGE": "subscriberStatusChange",
    "REG_UI_POP_UP_SHOWN": "reg-ui-show-pop-up",
    "REG_UI_POP_UP_CLOSED": "reg-ui-close-pop-up",
    "START_CHROME_CAST": "startChromeCast",
    "STOP_CHROME_CAST": "stopChromeCast",
    "SHOW_CLOSED_CAPTIONS": "showClosedCaptions",
    "HIDE_CLOSED_CAPTIONS": "hideClosedCaptions",
    "TRANSCRIPT_READY": "transcriptReady",
    "INTERNAL_TRANSCRIPT_ON": "interNalTranscriptOn",
    "INTERNAL_TRANSCRIPT_OFF": "internalTranscriptOff",
    "TRANSCRIPT_ON": "transcriptOn",
    "TRANSCRIPT_OFF": "transcriptOff",
    "THEATER_MODE_ON": "theaterModeOn",
    "THEATER_MODE_OFF": "theaterModeOff",
    "ENTER_THEATER_MODE": "enterTheaterMode",
    "THEATER_MODE_ENTER_BUTTON_CLICK": "theaterModeEnterButtonClick",
    "PLAYER_TOUT_ON": "playerToutOn",
    "VIEWABLE": "viewable",
    "UNVIEWABLE": "unviewable",
    "WILL_PLAY": "willPlay"
};

export default PlayerEvents;
